import { render, staticRenderFns } from "./MappingRenewalCreate.vue?vue&type=template&id=62d51d4f&scoped=true&"
import script from "./MappingRenewalCreate.vue?vue&type=script&lang=js&"
export * from "./MappingRenewalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d51d4f",
  null
  
)

export default component.exports